import {useEffect} from 'react';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import {filterTypes} from 'src/components/elements/account/AccountHistoryList';
import {
  HistoryComponent,
  HistoryComponentProps,
} from 'src/components/elements/account/newHistoryUI/historyComponent';

const OrderAheadHistoryList = (props: HistoryComponentProps) => {
  useEffect(() => {
    const filterValue = filterTypes.orderAhead;
    FirebaseAnalytic.trackEvent(
      'useEffect:componentDidMount',
      'OrderAheadHistoryList',
      {
        ...props,
        filterValue,
      },
    );
  }, []);
  return <HistoryComponent historyfilter={filterTypes.orderAhead} {...props} />;
};

export default OrderAheadHistoryList;
